import { Browser, OpenOptions } from '@capacitor/browser';
import { captureEvent } from '../event-capture';

const subscriptionPaywallLink =
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.DECKEE_CONFIG && window.DECKEE_CONFIG.subscriptionPaywallLink;

// NOTE: We don't use check capacitor plugin is available because we are manually handling if it's not
export const openWithInAppBrowser = async (
  options: OpenOptions,
): Promise<void> => {
  const opts = {
    toolbarColor: '#F2ECDF',
    ...options,
  };

  // There are some links that have been setup with `//` in front of them. Just prepend https: to them.
  if (options.url.indexOf('//') === 0) {
    opts.url = `https:${options.url}`;
  }

  try {
    await Browser.open(opts);
  } catch (e) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (window?.Capacitor?.platform === 'web') {
      console.log(
        'Error calling Browser.open! Fallback to window.location.href',
        e,
      );
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.location.href = options.url;
    } else {
      console.log('Error calling Browser.open! Not falling back', e);
    }
  }
};
export const openPaywall = async (
  memberId: string,
  prefillEmail: string,
  referrer: string,
  options?: OpenOptions,
): Promise<void> => {
  const paywallGeneratedUrl = new URL(subscriptionPaywallLink);
  paywallGeneratedUrl.searchParams.set('memberId', memberId);
  paywallGeneratedUrl.searchParams.set('email', prefillEmail);

  captureEvent({
    type: 'app: open paywall',
    payload: {
      referrer,
    },
  });

  return openWithInAppBrowser({
    ...options,
    url: paywallGeneratedUrl.href,
    windowName: '_self',
  });
};
